import { render, staticRenderFns } from "./GuiaTissInternacao.vue?vue&type=template&id=1886e3bb"
import script from "./GuiaTissInternacao.vue?vue&type=script&lang=ts"
export * from "./GuiaTissInternacao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports